export default __webpack_public_path__ + "225767b59a35e2e925d977b76ad48e3d.ttf";